import { component } from 'picoapp';
import { throttle } from 'lodash';

export default component(async (node) => {
  const checkSticky = () => {
    if (window.scrollY > 0) {
      node.parentElement.setAttribute('data-sticky', 'true');
    } else {
      node.parentElement.setAttribute('data-sticky', 'false');
    }
  };

  checkSticky();

  window.addEventListener('scroll', throttle(() => {
    checkSticky();
  }, 100));
});
